export function shared(): string {
  return 'shared';
}
export * from './utils/date-utils';
export * from './typings/api-constant';
export * from './typings/constants';
export * from './typings/db-config';
export * from './typings/layout-config';
export * from './typings/shared.model';
// export * from './typings/store-model';
